/* @ngInject */
const mySwitch = (utils) => {
  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      myNature: '=',
      myName: '=',
      myLabel: '=?',
      myIcon: '=?',
      myDisabled: '=?',
      myInit: '=?',
    },

    template: require('./mySwitch.html'),

    /* @ngInject */
    controller: ($scope) => {

      if ($scope.myInit !== undefined) {
        $scope.ngModel = $scope.myInit
      }
    },
    link: (scope, element, attrs) => {

    },
  }
}

export default mySwitch



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/mySwitch.js